<template>
    <div class="inline relative xl:ml-10 py-3" id="menu_item">
        <p :class="{'text-heading': isSelected}"
           @click.stop="clicked"
           class="inline menu fromLeft font-display hover:text-gray-700 pb-1 text-lg cursor-pointer opacity-enter-active"
        >
            {{ title }}
        </p>

        <transition name="opacity">
            <div class="absolute bottom-1 bg-heading w-full"
                 id="underline"
                 ref="underline"
                 v-if="isSelected"
            />
        </transition>
    </div>
</template>

<script>
export default {
    name: 'MenuItem',
    props: [
        'title',
        'itemKey',
        'activeKey',
    ],
    computed: {
        isSelected() {
            return this.activeKey === this.itemKey;
        },
    },
    methods: {
        clicked() {
            this.$emit('navigate-to', this.itemKey);

        },
    },
};
</script>

<style scoped>
#underline {
    height: 3%;
    position: absolute;
    left: 0px;
}

#menu_item {
    /* color: white; */
}
</style>
